import React, { useState, Fragment } from 'react';
import { useDisplayWidgetContext } from '../components/DisplayWidget/utils/context';

export default function ReadMoreReadLess(props) {
  const { totalWords = '30', children, readMoreFunctionality } = props;
  const [readMore, setReadMore] = useState(true);

  const handleReadMore = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (readMoreFunctionality) {
      readMoreFunctionality();
      return;
    }
    setReadMore(!readMore);
  };

  const { layout } = useDisplayWidgetContext();

  return (
    children && (
      <Fragment>
        {totalWords && readMore ? (
          <Fragment>
            {children?.split(' ')?.slice(0, totalWords).join(' ')}
            {children?.split(' ')?.length > parseInt(totalWords) && (
              <idk-div class="zid-text-right">
                <a
                  style={{ color: layout?.galleryColors?.readMoreBtnColor || '#3b82f6' }}
                  className="zidk-readmore zid-underline zid-cursor-pointer zid-text-xs"
                  onClick={handleReadMore}
                >
                  Read More
                </a>
              </idk-div>
            )}
          </Fragment>
        ) : (
          <Fragment>
            {children}{' '}
            <idk-div class="zid-text-right">
              {children?.split(' ')?.length > parseInt(totalWords) && (
                <a
                  style={{ color: layout?.galleryColors?.readMoreBtnColor || '#3b82f6' }}
                  className="zidk-readless zid-underline zid-cursor-pointer zid-text-xs"
                  onClick={handleReadMore}
                >
                  Read Less
                </a>
              )}
            </idk-div>
          </Fragment>
        )}
      </Fragment>
    )
  );
}
